/**
 * Created by quikr on 7/12/16.
 */
import React, {PropTypes} from "react";
import {connect} from "react-redux";
import Error from "../components/common/utils/Errors";
import axios from "axios";
import * as authActions from "../redux/actions/Authentication/authActions";
import CircularProgress from "material-ui/CircularProgress";
import {hashHistory} from "react-router";


class App extends React.Component {

  constructor() {
    super();
    this.state = ({show: false});
    this.toggle = this.toggle.bind(this);


  }

  toggle() {
    this.setState({show: !this.state.show});
  }

  componentDidMount() {
    if (!this.props.Auth[0].loggedIn) {

      if (window.location.href.indexOf("auth_code") != -1) {
        this.setState({show: true})
        this.props.dispatch(authActions.login({'id': window.location.search.split('=')[1]}, this.toggle));


      }
      else {
        this.setState({show: true});
        //http://accounts.quikr.com:13000/identity/v1/auth?clientId=hrms&redirectUri=http://192.168.101.88:3333&responseType=code&scope=openid&auth=Basic MkpWp9n1QvWIkunx2YwfuQ==
        //https://accounts.quikr.com/identity/v1/auth?clientId=hrms&redirectUri=https://hrms.quikrcorp.com&responseType=code&scope=openid&auth=Basic fOnLeHwsmThjrzmUeJEFiA==
        window.location = "https://hrms.quikrcorp.com/proxy/identity/v1/auth?clientId=hrms&redirectUri=https://hrms.quikrcorp.com&responseType=code&scope=openid&auth=Basic fOnLeHwsmThjrzmUeJEFiA==";
        // axios.get('/proxy/identity/v1/auth?clientId=hrms&redirectUri=https://hrms.quikrcorp.com&responseType=code&scope=openid&auth=Basic fOnLeHwsmThjrzmUeJEFiA==').then((response)=> {
        //   console.log(response);
        //   window.location = response.request.responseURL;
        //
        // }).catch((error)=> {
        //
        //   console.log(error);
        //
        // });
      }
    }
    else {
      if ((window.location.hash.length == 12 || window.location.hash == "")) {
        hashHistory.push('1');
      }
      if (window.location.href.indexOf("auth_code") != -1) {
        window.history.pushState('mainPage', 'Title', '/#/1');
      }

    }
  }

  componentWillReceiveProps(props) {

  }

  render() {


    return (
      <div>
        <Error/>
        <div  >
        </div>
        <div style={{"fontFamily": '"ProximaNova-Regular", "sans-serif"'}}>
          {this.state.show ?
            <div><CircularProgress style={{marginLeft: '46%', marginTop: '10%'}}/>Loading..</div> : this.props.children}
        </div>
      </div>
    );
  }

}

App.propTypes = {
  children: React.PropTypes.object,
  val: React.PropTypes.bool

};

function mapStateToProps(state, ownProps) {
  return {
    Auth: state.auth,
    val: state.ajaxCallsInProgress > 0
  };
}
export default connect(mapStateToProps)(App);



/** WEBPACK FOOTER **
 ** ./src/containers/App.js
 **/